import React, { useState, useEffect, useRef } from "react";
import { useOutletContext, Link } from "react-router-dom";

// import KindFoodNav from './KindFoodNav'
import ChooseFoodPart from "./ChooseFoodPart";

const ChoosFood = ({ searchQuery, qty, setQty, onAdd, increase, decrease }) => {
  const [active, setActive] = useState(null);
  const { cartItems, setCartItems } = useOutletContext();
  const itemsPrice = cartItems.reduce((a, c) => a + c.qty * c.price, 0);
  const exist = cartItems.find((x) => x.id === x.id);
  const formatPriceWithCommas = (price) => {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  return (
    <div className="bg-gray-300 relative dark:bg-gray-700">
      
      <ChooseFoodPart
        searchQuery={searchQuery}
        qty={qty}
        setQty={setQty}
        onAdd={onAdd}
        increase={increase}
        decrease={decrease}
      />
      {itemsPrice > 0 && (
        <>
          {itemsPrice < 999 && (
            <div className="sticky bottom-0 py-2 px-4 flex items-center justify-around bg-gray-100 dark:bg-gray-800">
              <p className="dark:text-white">مبلغ نهایی</p>
              <div className="flex gap-1 items-center dark:text-white">
                <p className="text-red-600 text-2xl font-bold">{itemsPrice}</p>
                <p>هزارتومان</p>
              </div>
              <Link to="/shopCart">
                <span className="h-8 w-8 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative  ">
                  <svg
                    className="dark:invert"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.4"
                      d="M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z"
                      fill="#292D32"
                    />
                    <path
                      d="M19.6509 10.7001H4.36094C4.07094 10.7001 3.75094 10.6901 3.46094 10.6101L4.72094 18.3001C5.00094 20.0201 5.75094 22.0001 9.08094 22.0001H14.6909C18.0609 22.0001 18.6609 20.3101 19.0209 18.4201L20.5309 10.6101C20.2509 10.6801 19.9509 10.7001 19.6509 10.7001ZM12.0009 18.5001C9.66094 18.5001 7.75094 16.5901 7.75094 14.2501C7.75094 13.8401 8.09094 13.5001 8.50094 13.5001C8.91094 13.5001 9.25094 13.8401 9.25094 14.2501C9.25094 15.7701 10.4809 17.0001 12.0009 17.0001C13.5209 17.0001 14.7509 15.7701 14.7509 14.2501C14.7509 13.8401 15.0909 13.5001 15.5009 13.5001C15.9109 13.5001 16.2509 13.8401 16.2509 14.2501C16.2509 16.5901 14.3409 18.5001 12.0009 18.5001Z"
                      fill="#292D32"
                    />
                  </svg>
                </span>
              </Link>
            </div>
          )}
          {itemsPrice > 999 && (
            <div className="sticky bottom-0 py-2 px-4 flex items-center justify-around bg-gray-100 dark:bg-gray-800">
              <p className="dark:text-white">مبلغ نهایی</p>
              <div className="flex gap-1 items-center dark:text-white">
                <p className="text-red-600 text-2xl font-bold">
                  {formatPriceWithCommas(itemsPrice)}
                </p>
                <p>میلیون تومان</p>
              </div>
              <Link to="/shopCart">
                <span className="h-8 w-8 shadow-md dark:bg-gray-800 shadow-gray-600 dark:shadow-slate-400 rounded flex justify-center items-center relative  ">
                  <svg
                    className="dark:invert"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.4"
                      d="M19.24 5.58006H18.84L15.46 2.20006C15.19 1.93006 14.75 1.93006 14.47 2.20006C14.2 2.47006 14.2 2.91006 14.47 3.19006L16.86 5.58006H7.14L9.53 3.19006C9.8 2.92006 9.8 2.48006 9.53 2.20006C9.26 1.93006 8.82 1.93006 8.54 2.20006L5.17 5.58006H4.77C3.87 5.58006 2 5.58006 2 8.14006C2 9.11006 2.2 9.75006 2.62 10.1701C2.86 10.4201 3.15 10.5501 3.46 10.6201C3.75 10.6901 4.06 10.7001 4.36 10.7001H19.64C19.95 10.7001 20.24 10.6801 20.52 10.6201C21.36 10.4201 22 9.82006 22 8.14006C22 5.58006 20.13 5.58006 19.24 5.58006Z"
                      fill="#292D32"
                    />
                    <path
                      d="M19.6509 10.7001H4.36094C4.07094 10.7001 3.75094 10.6901 3.46094 10.6101L4.72094 18.3001C5.00094 20.0201 5.75094 22.0001 9.08094 22.0001H14.6909C18.0609 22.0001 18.6609 20.3101 19.0209 18.4201L20.5309 10.6101C20.2509 10.6801 19.9509 10.7001 19.6509 10.7001ZM12.0009 18.5001C9.66094 18.5001 7.75094 16.5901 7.75094 14.2501C7.75094 13.8401 8.09094 13.5001 8.50094 13.5001C8.91094 13.5001 9.25094 13.8401 9.25094 14.2501C9.25094 15.7701 10.4809 17.0001 12.0009 17.0001C13.5209 17.0001 14.7509 15.7701 14.7509 14.2501C14.7509 13.8401 15.0909 13.5001 15.5009 13.5001C15.9109 13.5001 16.2509 13.8401 16.2509 14.2501C16.2509 16.5901 14.3409 18.5001 12.0009 18.5001Z"
                      fill="#292D32"
                    />
                  </svg>
                </span>
              </Link>
              
            </div>
            
          )}
        </>
      )}
    </div>
  );
};

export default ChoosFood;
